/**
 * Statické obchodní podmínky (VOP) pro veřejné stránky — prodej vzdělávacích
 * seminářů a programů na dálku. Obsah odpovídá reálnému flow aplikace:
 * online přihláška → potvrzení → faktura → účast. Pokrývá uzavření smlouvy,
 * cenu a platbu, storno, odstoupení (vč. výjimky § 1837 písm. j) pro akce
 * v určeném termínu) a reklamace, pro spotřebitele i podnikatele.
 *
 * POZN. pro provozovatele: stornovací lhůty a procenta v čl. 6 jsou nastaveny
 * na běžný oborový standard — před ostrým provozem je potvrď/uprav podle
 * skutečné obchodní politiky HCA.
 */
export function ObchodniPodminkyPage() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-16" data-testid="hca-obchodni-podminky-page">
      <div className="max-w-3xl">
        <h1 className="mb-4 text-4xl font-bold tracking-tight">Obchodní podmínky</h1>
        <p className="mb-2 text-muted-foreground">
          Tyto obchodní podmínky (dále jen „podmínky") upravují vzájemná práva a povinnosti při
          přihlášení a účasti na vzdělávacích seminářích a programech pořádaných společností HCA
          Czechia s.r.o. Tvoří nedílnou součást smlouvy uzavírané na dálku prostřednictvím těchto
          webových stránek.
        </p>
        <p className="text-sm text-muted-foreground">Účinné od 10. června 2026.</p>
      </div>

      <div className="prose prose-slate mt-8 max-w-3xl space-y-6 dark:prose-invert">
        <section>
          <h2 className="text-2xl font-semibold">1. Provozovatel</h2>
          <p className="text-muted-foreground">
            Poskytovatelem služeb je společnost{" "}
            <strong className="text-foreground">HCA Czechia s.r.o.</strong>, IČO 23530936, DIČ
            CZ23530936, se sídlem V aleji 238/57, Holásky, 620 00 Brno, zapsaná v obchodním
            rejstříku vedeném Krajským soudem v Brně, provozující vzdělávací programy pod značkou
            HCA Moravia (dále jen „poskytovatel").
          </p>
          <ul className="list-disc space-y-1 pl-5 text-muted-foreground">
            <li>
              <strong className="text-foreground">Telefon:</strong> +420 603 905 212
            </li>
            <li>
              <strong className="text-foreground">E-mail:</strong>{" "}
              <a className="underline" href="mailto:organizace@hcamoravia.cz">
                organizace@hcamoravia.cz
              </a>
            </li>
            <li>
              <strong className="text-foreground">Korespondenční adresa:</strong> Úlehlova 20a,
              Brno-Líšeň, 628 00
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">2. Vymezení pojmů</h2>
          <ul className="list-disc space-y-1 pl-5 text-muted-foreground">
            <li>
              <strong className="text-foreground">Seminář</strong> — vzdělávací akce, kurz nebo
              program pořádaný poskytovatelem v určeném termínu a místě.
            </li>
            <li>
              <strong className="text-foreground">Objednatel</strong> — osoba, která odešle
              přihlášku; může jím být fyzická osoba (účastník) nebo firma, která přihlašuje své
              zaměstnance.
            </li>
            <li>
              <strong className="text-foreground">Účastník</strong> — fyzická osoba, která se
              semináře skutečně účastní.
            </li>
            <li>
              <strong className="text-foreground">Spotřebitel</strong> — člověk, který uzavírá
              smlouvu mimo rámec své podnikatelské činnosti.{" "}
              <strong className="text-foreground">Podnikatel</strong> — objednatel jednající v rámci
              své podnikatelské činnosti (typicky firemní objednávka na IČO).
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">3. Předmět smlouvy</h2>
          <p className="text-muted-foreground">
            Předmětem smlouvy je závazek poskytovatele uspořádat seminář v rozsahu a termínu
            uvedeném u konkrétní nabídky a umožnit účast přihlášenému účastníkovi, a závazek
            objednatele zaplatit za účast sjednanou cenu. Aktuální nabídka seminářů, jejich obsah,
            termíny, místo, délka a cena jsou uvedeny na webových stránkách u jednotlivých termínů.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">4. Přihláška a uzavření smlouvy</h2>
          <p className="text-muted-foreground">
            Vyplněním a odesláním přihlašovacího formuláře u zvoleného termínu podává zájemce{" "}
            <strong className="text-foreground">nezávaznou přihlášku</strong> — tj. projev zájmu o
            účast. Odesláním přihlášky zájemci <strong className="text-foreground">nevzniká</strong>{" "}
            povinnost úhrady. Před odesláním lze vložené údaje zkontrolovat a měnit.
          </p>
          <p className="text-muted-foreground">
            Po přijetí přihlášky poskytovatel zájemce kontaktuje a účast potvrdí.{" "}
            <strong className="text-foreground">
              Smlouva (a s ní povinnost uhradit cenu) vzniká až tímto potvrzením účasti ze strany
              poskytovatele (HCA Moravia)
            </strong>
            , nikoli samotným odesláním přihlášky. Poskytovatel si vyhrazuje právo přihlášku
            nepotvrdit, zejména při naplnění kapacity termínu; o tom zájemce bez zbytečného odkladu
            informuje.
          </p>
          <p className="text-muted-foreground">
            <strong className="text-foreground">Postup:</strong> výběr termínu → vyplnění
            přihlašovacího formuláře → kontrola údajů → odeslání nezávazné přihlášky → kontakt a
            potvrzení účasti ze strany poskytovatele.
          </p>
          <p className="text-muted-foreground">
            Smlouva se uzavírá v českém jazyce. Uzavřenou smlouvu (potvrzenou přihlášku spolu s
            těmito podmínkami) poskytovatel uchovává a objednateli ji na vyžádání zpřístupní na výše
            uvedeném e-mailu.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">5. Cena a platební podmínky</h2>
          <ul className="list-disc space-y-1 pl-5 text-muted-foreground">
            <li>Ceny jsou uvedeny v českých korunách (Kč) u jednotlivých termínů.</li>
            <li>
              Poskytovatel je plátcem DPH; informace o tom, zda je cena uvedena s DPH či bez DPH, je
              uvedena u konkrétního semináře a na daňovém dokladu.
            </li>
            <li>
              Cena se hradí na základě faktury (daňového dokladu) vystavené po potvrzení účasti
              poskytovatelem, bankovním převodem, ve lhůtě splatnosti uvedené na faktuře (zpravidla
              14 dnů).
            </li>
            <li>
              Cena se považuje za uhrazenou dnem připsání částky na účet poskytovatele. Daňový
              doklad je vystaven v souladu s platnými právními předpisy.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">6. Změna účastníka a storno podmínky</h2>
          <p className="text-muted-foreground">
            <strong className="text-foreground">Náhradník:</strong> objednatel může kdykoli před
            zahájením semináře a bez poplatku nahradit přihlášeného účastníka jinou osobou; změnu
            stačí oznámit e-mailem.
          </p>
          <p className="text-muted-foreground">
            <strong className="text-foreground">Storno ze strany objednatele</strong> (zrušení
            účasti) se řídí podle počtu dnů zbývajících do zahájení semináře:
          </p>
          <ul className="list-disc space-y-1 pl-5 text-muted-foreground">
            <li>více než 30 dnů předem — bez storno poplatku (vrací se 100 % ceny),</li>
            <li>30 až 14 dnů předem — storno poplatek 50 % ceny,</li>
            <li>méně než 14 dnů předem nebo neúčast bez omluvy — storno poplatek 100 % ceny.</li>
          </ul>
          <p className="text-muted-foreground">
            Storno je nutné provést písemně (e-mailem). Namísto storna lze vždy využít bezplatné
            nahrazení účastníka.
          </p>
          <p className="text-muted-foreground">
            <strong className="text-foreground">
              Zrušení nebo přesun ze strany poskytovatele:
            </strong>{" "}
            poskytovatel je oprávněn seminář zrušit nebo přesunout zejména z důvodu nízkého počtu
            přihlášených nebo nepředvídatelných překážek. V takovém případě nabídne objednateli
            náhradní termín nebo vrátí celou uhrazenou cenu do 14 dnů.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">7. Odstoupení od smlouvy</h2>
          <p className="text-muted-foreground">
            <strong className="text-foreground">Spotřebitel</strong> má u smluv uzavřených na dálku
            zpravidla právo odstoupit od smlouvy do 14 dnů. Toto právo se však{" "}
            <strong className="text-foreground">neuplatní</strong> u smlouvy o využití volného času,
            je-li plnění poskytováno v určeném termínu (§ 1837 písm. j) občanského zákoníku) — tj. u
            seminářů a akcí konaných v konkrétní den. Spotřebitel, jehož účast již byla potvrzena,
            proto namísto odstoupení postupuje podle storno podmínek v čl. 6. Tato výjimka se
            vztahuje na akce vázané na konkrétní termín; u případného plnění bez pevně určeného
            termínu se uplatní obecné právo spotřebitele odstoupit do 14 dnů.
          </p>
          <p className="text-muted-foreground">
            <strong className="text-foreground">Podnikatel</strong> (firemní objednávka): ustanovení
            o ochraně spotřebitele se neuplatní; zrušení účasti se řídí výhradně storno podmínkami v
            čl. 6.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">8. Práva z vadného plnění (reklamace)</h2>
          <p className="text-muted-foreground">
            Má-li seminář vady (například neodpovídá-li svým obsahem nebo rozsahem nabídce), má
            objednatel právo vadu reklamovat. Reklamaci uplatněte bez zbytečného odkladu e-mailem na{" "}
            <a className="underline" href="mailto:organizace@hcamoravia.cz">
              organizace@hcamoravia.cz
            </a>
            . Je-li objednatel spotřebitelem, poskytovatel reklamaci vyřídí nejpozději do 30 dnů a o
            jejím uplatnění i způsobu vyřízení vydá objednateli písemné potvrzení. Je-li reklamace
            oprávněná, sjedná poskytovatel nápravu (např. náhradní termín nebo přiměřenou slevu).
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">9. Ochrana osobních údajů</h2>
          <p className="text-muted-foreground">
            Osobní údaje zpracovává poskytovatel v souladu s nařízením GDPR. Podrobnosti o tom, jaké
            údaje, proč a jak dlouho zpracováváme a jaká máte práva, najdete v dokumentu{" "}
            <a className="underline" href="/gdpr" target="_blank" rel="noreferrer">
              Zásady ochrany osobních údajů
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">10. Mimosoudní řešení spotřebitelských sporů</h2>
          <p className="text-muted-foreground">
            Je-li objednatel spotřebitelem a vznikne-li mezi stranami spor, který se nepodaří
            vyřešit dohodou, má spotřebitel právo obrátit se na subjekt mimosoudního řešení
            spotřebitelských sporů, kterým je{" "}
            <strong className="text-foreground">Česká obchodní inspekce</strong>, Štěpánská 567/15,
            120 00 Praha 2,{" "}
            <a
              className="underline"
              href="https://www.coi.cz"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.coi.cz
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">11. Závěrečná ustanovení</h2>
          <p className="text-muted-foreground">
            Vztahy těmito podmínkami neupravené se řídí právním řádem České republiky, zejména
            zákonem č. 89/2012 Sb., občanským zákoníkem, a u spotřebitelů zákonem č. 634/1992 Sb., o
            ochraně spotřebitele. Je-li některé ustanovení podmínek neplatné, nemá to vliv na
            platnost ostatních ustanovení.
          </p>
          <p className="text-muted-foreground">
            Poskytovatel může znění podmínek měnit; pro každou objednávku platí podmínky účinné ke
            dni jejího odeslání. Aktuální verze je vždy zveřejněna na této stránce s uvedeným datem
            účinnosti.
          </p>
        </section>
      </div>
    </div>
  );
}
